import React, { useCallback, useEffect, useState } from "react";
import "./digitMemorySpan.scss";
import TestFooter from "../testFooter/testFooter";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import { message } from "antd";
import { answeredQues } from "../../helper/testHelper";
import { LaunchTestContext } from "../../store/launchTestStore";
import { createShuffledArray } from "../../helper/nextQues";
import useTimer from '../../Hooks/useTimer';
import { totalTimeOrScoreDigitSpan } from "../../helper/scoreCounter";
import { getStudentData } from "../../helper/localStorage";
import { addTestResult } from "../../api/addTestResult";

const DigitMemorySpan = ({ question, questions, index }) => {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();
  const { launchTestC, dispatchLaunchTest } = LaunchTestContext();
  const [displayNumberIdx, setDisplayNumberIdx] = useState(-1); // Initialize with -1
  const [displayAllNumbers, setDisplayAllNumbers] = useState(false); // Track if all numbers are displayed
  const [remainingAttempt, setRemainingAttempt] = useState(3);
  const [wrongQuestion, setWrongQuestion] = useState(0);
  const [userInput, setUserInput] = useState([]);
  const {pause, reset, start, time} = useTimer();

  const { launchTestData } = launchTestC;
  const { test_format } = launchTestData.data[0];

  const isReverseTest = test_format === "digit_reverse_span";

  const grade_id = JSON.parse(localStorage.getItem("gradeId"));
  const { login_id } = getStudentData();

  const { isNextQues } = helperC;
  const questionArr = [...question.que_title2];
  if (isReverseTest) {
    questionArr.reverse();
  }
  const handleUserInput = (input) => {
    setUserInput((prev) => {
      const newArr = [...prev];
      const inputIndex = newArr.indexOf(input);
      if (inputIndex > -1) {
        newArr[inputIndex] = "";
      } else {
        const emptyIndex = newArr.indexOf("");
        if (emptyIndex !== -1) {
          newArr[emptyIndex] = input;
        } else if (newArr.length < question.que_title2.length) {
          newArr.push(input);
        }
      }

      return newArr;
    });
  };

  const handleBoxClick = (index) => {
    setUserInput((prev) => {
      const newArr = [...prev];
      newArr[index] = "";
      return newArr;
    });
  };

  const handleNext = () => {
    if (userInput.toString() !== question.correct_text) {
      handleWrongInput();
      return;
    }
    const nextTest = questions[index + 1];
    if (index < questions.length - 1) {
      dispatchAnswer({
        type: "ADD_ANSWER",
        payload: {...answeredQues(
          "digit_span",
          userInput.toString(),
          question,
          time * 1000
        ), test_id: question.test_id, answer_flag: `${wrongQuestion} - Incorrect Attempt`},
      });
      setWrongQuestion(0);
      reset();
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: nextTest.id,
      });
    } else {
      dispatchAnswer({
        type: "ADD_ANSWER",
        payload: {...answeredQues(
          "digit_span",
          userInput.toString(),
          question,
          time * 1000
        ), test_id: question.test_id, answer_flag: `${wrongQuestion} - Incorrect Attempt`},
      });
      const answerRes = [...answerC.answers];
      const { player_time, player_score } = totalTimeOrScoreDigitSpan(
        answerRes,
        questions,
        false //is reaction test
      );
      const formatValue = {
        grade_id,
        player_id: login_id,
        res: answerRes, // Use the updated answers here
        player_image: "",
        player_time,
        player_score,
        test_id: question.test_id,
      };
      addTestResult(formatValue, dispatchHelper, dispatchAnswer);
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: "submitted",
      });
    }
  };

  const handleWrongInput = useCallback(() => {
    message.destroy();
    if (wrongQuestion + 1 !== 3) {
      message.error({
        content:
          `You've Attempted this question wrong. Re-attempt question again.\nRemaining Attempts are ${2 - wrongQuestion}`,
      });
    }else{
      dispatchAnswer({
        type: "ADD_ANSWER",
        payload: {...answeredQues(
          "digit_span",
          userInput.toString(),
          question,
          time * 1000
        ), test_id: question.test_id, answer_flag: `${wrongQuestion + 1} - Incorrect Attempt`},
      });
    }
    const { launchTestData } = launchTestC;
    const newQuestion = { ...launchTestData };
    const queArr = createShuffledArray(question.que_title2.length);
    newQuestion.data[0].que[index].que_title2 = [...queArr];

    newQuestion.data[0].que[index].correct_text = isReverseTest
      ? [...queArr].reverse().toString()
      : [...queArr].toString();

    dispatchLaunchTest({
      type: "RUNNING_TEST_DATA",
      payload: newQuestion,
    });
    dispatchHelper({ type: "SHOWING_NUMBERS", payload: true });
    reset();
    setRemainingAttempt(3);
    setDisplayNumberIdx(-1);
    setUserInput([]);
    setWrongQuestion((prev) => prev + 1);

  }, [
    dispatchLaunchTest,
    index,
    launchTestC,
    question.que_title2.length,
    remainingAttempt,
    reset,
  ]);

  useEffect(() => {
    if (wrongQuestion === 3) {
      const answerRes = [
        ...answerC.answers,
      ]

      const { player_time, player_score } = totalTimeOrScoreDigitSpan(
        answerRes,
        questions,
        false //is reaction test
      );
      const formatValue = {
        grade_id,
        player_id: login_id,
        res: answerRes,
        player_image: "",
        player_time,
        player_score,
        test_id: question.test_id,
      };
      addTestResult(formatValue, dispatchHelper, dispatchAnswer);
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: "submitted",
      });
    }
  }, [dispatchHelper, wrongQuestion]);

  useEffect(() => {
    const numbersArr = questionArr;
    let timeout;
    let time = displayNumberIdx === -1 ? 1200 : 1450;

    const displayNumbers = () => {
      if (!displayAllNumbers && displayNumberIdx < numbersArr.length) {
        setTimeout(() => {
          setDisplayNumberIdx(displayNumberIdx + 1); // Increment index to display next number
        }, time);
      } else {

        setDisplayAllNumbers(true);
        setDisplayNumberIdx(null);
      }
    };

    timeout = displayNumbers(); // Start displaying numbers

    return () => clearTimeout(timeout);
  }, [displayNumberIdx, question, launchTestC]);

  useEffect(() => {
    let timeout;
    if (displayAllNumbers) {
      timeout = setTimeout(() => {
        setDisplayAllNumbers(false);
        dispatchHelper({ type: "SHOWING_NUMBERS", payload: false });
        start()
      }, 1450);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [displayAllNumbers]);

  useEffect(() => {
    if (isNextQues) {
      handleNext();
      dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
    }
  }, [isNextQues, helperC]);

  useEffect(() => {
    dispatchHelper({ type: "SHOWING_NUMBERS", payload: true });
    pause();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div className="test-header question">{question.que_title1}</div>
      <div className="question-digit">{question.que_title2.length} Digit</div>
      <div className="flex-container">
        {[...question.que_title2]
          .join("+")
          .padEnd(19, "+ ")
          .split("+")
          .map((num, idx) => {
            return (
              <div
                className={`box ${(idx + 1) > question.que_title2.length && (displayNumberIdx > -1 && displayNumberIdx === null) && !displayAllNumbers ? 'empty' : ''}`}
                onClick={() => handleBoxClick(idx)}
              >
                {idx === displayNumberIdx && !displayAllNumbers
                  ? num
                  : displayAllNumbers
                  ? num
                  : userInput[idx] !== undefined ? userInput[idx] : ""}
              </div>
            );
          })}
      </div>
      <div className="second-message">Click the numbers in the {isReverseTest ? 'reverse' : 'same'} order they are presented to you</div>
      <div className="buttons-container">
        {Array.from(Array(10).keys())
          .reverse()
          .map((item) => {
            return (
              <button
                className={`button ${
                  userInput.includes(item) ? "selected" : ""
                }`}
                disabled={
                  displayNumberIdx !== null ||
                  displayAllNumbers
                }
                onClick={() => handleUserInput(item)}
              >
                {item}
              </button>
            );
          })}
      </div>
      <TestFooter
        index={index}
        question={question}
        questions={questions}
        isUserInput={
          userInput.filter((item) => item !== " ").length ===
          question.que_title2.length
        }
      />
    </div>
  );
};

export default DigitMemorySpan;
